import createAction from '@clearscore/helpers.create-action';

import {
    PROTECT_WELCOME_CTA_CLICK,
    PROTECT_EMAIL_VERIFY_CLICK,
    PROTECT_BENEFITS_CLICK,
    PROTECT_PAYMENT_SUCCESS_CLICK,
    PROTECT_ACTION_OPENED,
    PROTECT_BREACH_DRAWER_OPENED,
    PROTECT_BREACH_DRAWER_CLOSED,
    PROTECT_INFO_DRAWER_OPENED,
    PROTECT_REALTIME_UPGRADE_CLICKED,
    PROTECT_MORE_BUTTON_CLICKED,
    PROTECT_REMIND_ME_LATER_CLICKED,
} from './types';

export const welcomeCtaClicked = createAction(PROTECT_WELCOME_CTA_CLICK);
export const emailVerifyClicked = createAction(PROTECT_EMAIL_VERIFY_CLICK);
export const paymentSuccessClicked = createAction(PROTECT_PAYMENT_SUCCESS_CLICK);
export const realtimeUpgradeClicked = createAction(PROTECT_REALTIME_UPGRADE_CLICKED);
export const benefitsClicked = createAction(PROTECT_BENEFITS_CLICK);

export const protectActionOpened = (context) => createAction(PROTECT_ACTION_OPENED, context);

export const breachDrawerOpened = (data) => createAction(PROTECT_BREACH_DRAWER_OPENED, { context: { ...data } });

export const breachDrawerClosed = (data) => createAction(PROTECT_BREACH_DRAWER_CLOSED, { context: { ...data } });

export const infoDrawerOpened = (data) => createAction(PROTECT_INFO_DRAWER_OPENED, { context: { ...data } });

export const realTimeUpgradeClicked = (data) =>
    createAction(PROTECT_REALTIME_UPGRADE_CLICKED, { context: { ...data } });

export const moreButtonClicked = (data) => createAction(PROTECT_MORE_BUTTON_CLICKED, { context: { ...data } });

export const remindMeLaterClicked = (data) => createAction(PROTECT_REMIND_ME_LATER_CLICKED, { context: { ...data } });
